import React, { useState, useEffect } from 'react';
import './PuzzleGame.css';

export default function PuzzleGame() {
  const gridSize = 4; // Creates a 4x4 puzzle grid (can adjust size if desired)
  const totalTiles = gridSize * gridSize;
  const [tiles, setTiles] = useState([]);
  const [emptyIndex, setEmptyIndex] = useState(totalTiles - 1); // Last position is the empty space

  // Initialize the tiles in order and shuffle them
  useEffect(() => {
    const orderedTiles = Array.from({ length: totalTiles - 1 }, (_, i) => i + 1);
    orderedTiles.push(null); // Last tile is the empty space
    setTiles(shuffleTiles(orderedTiles));
  }, []);

  // Function to shuffle the tiles randomly
  const shuffleTiles = (tilesArray) => {
    let shuffledTiles = [...tilesArray];
    for (let i = shuffledTiles.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledTiles[i], shuffledTiles[j]] = [shuffledTiles[j], shuffledTiles[i]];
    }
    return shuffledTiles;
  };

  // Handle tile click
  const handleTileClick = (index) => {
    if (isAdjacent(index, emptyIndex)) {
      const newTiles = [...tiles];
      [newTiles[index], newTiles[emptyIndex]] = [newTiles[emptyIndex], newTiles[index]];
      setTiles(newTiles);
      setEmptyIndex(index);

      if (isPuzzleSolved(newTiles)) {
        alert("Congratulations! You solved the puzzle!");
      }
    }
  };

  // Check if two indices are adjacent
  const isAdjacent = (index1, index2) => {
    const row1 = Math.floor(index1 / gridSize);
    const col1 = index1 % gridSize;
    const row2 = Math.floor(index2 / gridSize);
    const col2 = index2 % gridSize;
    return (Math.abs(row1 - row2) + Math.abs(col1 - col2) === 1);
  };

  // Check if the puzzle is solved
  const isPuzzleSolved = (tilesArray) => {
    for (let i = 0; i < totalTiles - 1; i++) {
      if (tilesArray[i] !== i + 1) return false;
    }
    return true;
  };

  return (
    <div className="puzzle-game">
      <h1>Puzzle Game</h1>
      <button onClick={() => setTiles(shuffleTiles(tiles))}>Shuffle</button>
      <div className="puzzle-grid" style={{ gridTemplateColumns: `repeat(${gridSize}, 1fr)` }}>
        {tiles.map((tile, index) => (
          <div
            key={index}
            className={`tile ${tile === null ? 'empty' : ''}`}
            onClick={() => handleTileClick(index)}
          >
            {tile}
          </div>
        ))}
      </div>
    </div>
  );
}
